<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Operaciones</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Fecha Inicio</th>
              <th scope="col" class="text-center">Fecha Fin</th>
              <!-- <th scope="col" class="text-center">Tipo</th> -->
            </tr>
          </thead>
          <tbody v-if="eventsLoaded">
            <template v-if="paginatedItems.length > 0">
              <tr v-for="(item, index) in paginatedItems" :key="item.id">
                <td class="text-center">
                  <div class="btn-group">
                    <button class="btn btn-success" @click="getEvent(item.id)">
                      Inscripción
                    </button>
                    <button
                      class="btn btn-primary"
                      @click="getAttendance(item.id)"
                    >
                      Asistencia
                    </button>
                  </div>
                </td>
                <template v-if="item.state === 2">
                  <td class="text-center">
                    <span class="badge bg-success">Activo</span>
                  </td>
                </template>
                <template v-else-if="item.state === 3">
                  <td class="text-center">
                    <span class="badge bg-danger">Concluido</span>
                  </td>
                </template>
                <td class="text-center" style="max-width: 250px">
                  {{ item.title }}
                </td>
                <td class="text-center">{{ formatDate(item.init_date) }}</td>
                <td class="text-center">{{ formatDate(item.end_date) }}</td>
                <!-- <td>Interno</td> -->
              </tr>
            </template>
            <tr v-else>
              <td colspan="6">
                <EmptyState
                  title="No tiene eventos registrados o aprobados."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr colspan="5" class="mt-2 text-center">
              Cargando eventos...
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, inject, computed } from "vue";
import axios from "@/includes/connection";
import EmptyState from "@/components/emptyState.vue";

import Pagination from "@/pages/components/Pagination.vue";

const list = ref([]);

const swal = inject("$swal");

const eventsLoaded = ref(false);

import { useRouter } from "vue-router";
const router = useRouter();

onMounted(() => {
  loadItems();
});

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function loadItems() {
  axios
    .get(`/event/userEvents`)
    .then((response) => {
      //console.log("list", response.data);
      if (response.data) {
        list.value = response.data;
        eventsLoaded.value = true;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

const getEvent = (code) => {
  //console.log(code);
  router.push({ name: "list_participants", params: { id: code } });
};

const getAttendance = (code) => {
  //console.log(code);
  router.push({ name: "list_participants_attendance", params: { id: code } });
};

const sortedList = computed(() => {
  return list.value.sort((a, b) => b.id - a.id);
});

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  //return list.value.slice(startIndex, endIndex);
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
